import { useState } from 'react';

import { FloatingFocusManager, FloatingPortal } from '@floating-ui/react';
import { faBug } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { AdminLinks } from '@spacefill/external-console/src/layout/AdminLinks';
import { CopyContextButton } from '@spacefill/external-console/src/layout/CopyContextButton';
import { BACKEND_LIST, BACKEND_URL_LIST } from '@spacefill/shared/src/constants/Backend';
import { useFloatingDropdown } from '@spacefill/shared/src/hooks/useFloatingDropdown';
import { FeatureTogglingToolbar } from '@spacefill/shared/src/utils/FeatureToggling';
import { getEnvironmentVariable } from '@spacefill/shared/src/utils/GetEnvVar';

import { Button } from './components/Button/index';
import { SelectBackend } from './components/SelectBackend';

export function SpacefillDebugActions() {
    const { isOpen, refs, floatingStyles, context, getReferenceProps, getFloatingProps, styles, isMounted, maxHeight } =
        useFloatingDropdown();

    const backends = Object.values(BACKEND_LIST);
    const [selectedBackend, setSelectedBackend] = useState(() => {
        const backendUrl = getEnvironmentVariable('backendUrl');
        const backendKey = Object.keys(BACKEND_URL_LIST).find((key) => BACKEND_URL_LIST[key] === backendUrl);
        return backendKey || 'LOCAL';
    });

    return (
        <div className='flex items-center gap-1.5'>
            <div
                ref={refs.setReference}
                {...getReferenceProps()}
            >
                <Button
                    variant='tertiary'
                    size='small'
                    iconStart={<FontAwesomeIcon icon={faBug} />}
                    dataTestid='debug'
                >
                    Debug
                </Button>
            </div>
            <>
                {isOpen && (
                    <FloatingPortal>
                        <FloatingFocusManager
                            context={context}
                            modal={false}
                        >
                            <div
                                ref={refs.setFloating}
                                style={{ ...floatingStyles, ...(maxHeight ? { maxHeight } : {}) }}
                                {...getFloatingProps()}
                                className='z-dropdown flex rounded-md bg-white p-2 drop-shadow-xl'
                            >
                                {isMounted && (
                                    <div
                                        style={styles}
                                        className='flex flex-col gap-3'
                                    >
                                        <SelectBackend
                                            backends={backends}
                                            selectedBackend={selectedBackend}
                                            setSelectedBackend={setSelectedBackend}
                                        />
                                        <FeatureTogglingToolbar />
                                        <AdminLinks />
                                        <CopyContextButton />
                                    </div>
                                )}
                            </div>
                        </FloatingFocusManager>
                    </FloatingPortal>
                )}
            </>
        </div>
    );
}
